export enum ProjectEventBudgetType {
  BUDGET = "BUDGET",
  NON_BUDGET = "NON_BUDGET",
  SAVING = "SAVING",
}
